module.exports = __webpack_public_path__ + "static/img/im4.9bc6088b.png";